import { VehicleTypeUpdateForm } from 'components/Pages/VehicleTypes';
import { Scaffold } from 'layouts';
import React, { useCallback } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

export const VehicleTypeUpdatePage: React.FC = () => {
  const { id } = useParams() as { id: string };
  const navigate = useNavigate();

  const onUpdate = useCallback((): void => {
    navigate('/configuracoes/tipos-veiculo');
  }, [navigate]);

  return (
    <Scaffold>
      <VehicleTypeUpdateForm vehicleTypeId={id} onUpdate={onUpdate} />
    </Scaffold>
  );
};
